import { useReveal } from "../../lib/hooks";

export function Mission() {
  const { ref } = useReveal<HTMLDivElement>();
  const { ref: imgRef } = useReveal<HTMLDivElement>();

  return (
    <section id="mission" className="relative py-20 md:py-24 overflow-hidden">
      {/* Baba presence — static cutout, tucked into the far-left margin.
          Sits below the text column so it never overlaps the prose. */}
      <div
        aria-hidden
        className="hidden xl:block absolute pointer-events-none select-none"
        style={{
          bottom: "-4%",
          left: "-4%",
          width: "clamp(13rem, 16vw, 18rem)",
          zIndex: 0,
          contain: "strict",
          contentVisibility: "auto",
          containIntrinsicSize: "18rem 30rem",
        }}
      >
        <img
          src="/photos/baba-cutout.png"
          alt=""
          className="w-full h-auto block"
          style={{ opacity: 0.4 }}
          loading="lazy"
          decoding="async"
        />
      </div>

      <div className="container-edit relative" style={{ zIndex: 1 }}>
        <div className="section-heading">
          <span className="section-heading-num tabular">01 / Mission</span>
          <hr className="rule flex-1 hidden sm:block" />
        </div>

        <div className="grid grid-cols-12 gap-y-16 lg:gap-x-16 items-start">
          {/* Mission text */}
          <div ref={ref} className="col-span-12 lg:col-span-7 reveal">
            <h2 className="font-display text-[clamp(2.5rem,6vw,5rem)] leading-[1.02] tracking-[-0.02em] mb-12">
              Connecting those who{" "}
              <span className="font-display-italic" style={{ color: "var(--color-violet)" }}>
                chant the Vedas
              </span>{" "}
              — across countries, lineages, and lifetimes.
            </h2>

            <div className="grid sm:grid-cols-2 gap-x-12 gap-y-6 max-w-3xl">
              <p className="drop-cap text-[1.05rem] leading-[1.7] text-[var(--color-ink-soft)]">
                Veda Union seeks to unite the world on a spiritual level — promoting
                unity, love, and peace among all through the teachings of the Vedas
                and the recitation of the sacred hymns. What began in 2010 as a
                pan-European network has, in the years since, become a worldwide
                community: people of many countries, languages, and traditions
                coming together around a practice that has been carried, almost
                unchanged, for thousands of years.
              </p>
              <p className="text-[1.05rem] leading-[1.7] text-[var(--color-ink-soft)]">
                We recognise the unity of the world's spiritual heritage and
                celebrate its diversity. No one is asked to convert; no lineage is
                required. The Vedas have stayed alive for millennia by belonging to
                everyone, and we try to honour that. The door stays open.
                <br />
                <br />
                Founded by{" "}
                <span className="font-display-italic">Vojko Kercan</span> and{" "}
                <span className="font-display-italic">Branimir Gonan</span>, the
                project began with the blessing of Bhagawan Sri Sathya Sai Baba —
                who accepted their letter and gave the work its name.
              </p>
            </div>
          </div>

          {/* Image — wide community gathering, anjali mudra */}
          <div ref={imgRef} className="col-span-12 lg:col-span-5 reveal">
            <figure>
              <div
                className="image-frame aspect-[4/5]"
                style={{ outline: "1px solid var(--color-rule-violet)", outlineOffset: "10px" }}
              >
                <img
                  src="/photos/gathering-anjali.jpg"
                  alt="A wide gathering of practitioners in white, hands folded in añjali mudrā during Vedic chanting"
                  loading="lazy"
                />
              </div>
              <figcaption className="mt-12 flex items-baseline gap-3 text-[0.78rem] tracking-[0.16em] uppercase text-[var(--color-ink-mute)] font-grotesk">
                <span>Plate</span>
                <span className="tabular" style={{ color: "var(--color-violet)" }}>
                  i.
                </span>
                <span className="text-[var(--color-ink-mute)]">
                  Community in añjali mudrā
                </span>
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>
  );
}
